__turbopack_context__.v({
  "answerCard": "Ir8L-W_answerCard",
  "chapterNav": "Ir8L-W_chapterNav",
  "chapterRule": "Ir8L-W_chapterRule",
  "compactStory": "Ir8L-W_compactStory",
  "connectedCards": "Ir8L-W_connectedCards",
  "customerConnections": "Ir8L-W_customerConnections",
  "customerFocus": "Ir8L-W_customerFocus",
  "evidence": "Ir8L-W_evidence",
  "evidenceFoot": "Ir8L-W_evidenceFoot",
  "evidenceGrid": "Ir8L-W_evidenceGrid",
  "evidenceHeader": "Ir8L-W_evidenceHeader",
  "evidenceIntro": "Ir8L-W_evidenceIntro",
  "flowArt": "Ir8L-W_flowArt",
  "flowCaption": "Ir8L-W_flowCaption",
  "flowLines": "Ir8L-W_flowLines",
  "flowTwin": "Ir8L-W_flowTwin",
  "footer": "Ir8L-W_footer",
  "hint": "Ir8L-W_hint",
  "kicker": "Ir8L-W_kicker",
  "landingStory": "Ir8L-W_landingStory",
  "layerButtons": "Ir8L-W_layerButtons",
  "layerCaption": "Ir8L-W_layerCaption",
  "layerCopy": "Ir8L-W_layerCopy",
  "layerDetail": "Ir8L-W_layerDetail",
  "layerGrid": "Ir8L-W_layerGrid",
  "layerVisual": "Ir8L-W_layerVisual",
  "layers": "Ir8L-W_layers",
  "miniRecord": "Ir8L-W_miniRecord",
  "page": "Ir8L-W_page",
  "pageNav": "Ir8L-W_pageNav",
  "particleLayer": "Ir8L-W_particleLayer",
  "particlePath": "Ir8L-W_particlePath",
  "particles": "Ir8L-W_particles",
  "proofAnswer": "Ir8L-W_proofAnswer",
  "proofCard": "Ir8L-W_proofCard",
  "proofQuestion": "Ir8L-W_proofQuestion",
  "proofSource": "Ir8L-W_proofSource",
  "scrollReset": "Ir8L-W_scrollReset",
  "sourceButtons": "Ir8L-W_sourceButtons",
  "sourceIcon": "Ir8L-W_sourceIcon",
  "sourceLabels": "Ir8L-W_sourceLabels",
  "statusDot": "Ir8L-W_statusDot",
  "sticky": "Ir8L-W_sticky",
  "story": "Ir8L-W_story",
  "storyArt": "Ir8L-W_storyArt",
  "storyCopy": "Ir8L-W_storyCopy",
  "storyHead": "Ir8L-W_storyHead",
  "studyIntro": "Ir8L-W_studyIntro",
  "textButton": "Ir8L-W_textButton",
  "trail": "Ir8L-W_trail",
  "trailMove": "Ir8L-W_trailMove",
  "workspaceStage": "Ir8L-W_workspaceStage",
});
